import React, { Component } from 'react';
import axios from "axios"
export default class ShowImage extends Component {
  constructor(props) {
    super(props);
    this.click = this.click.bind(this)
    this.state = {
      deleted: false
    };
  }
  click(){
    axios.post("/api/v1/experts/app/entree/dashboard/destroyImage",{
      id: this.props.rdvid,imgid: this.props.img.id,
      expertiseid: this.props.expertiseid
    }).then((data)=>{
      this.setState({deleted: true})
    })
  }
  render() {
    if(this.state.deleted){
      return(<div></div>)
    }else{
    return (
      <div style={styles.container} >
        <img src={this.props.img.url} className="responsive-img" alt=""/>
        <div style={styles.delete} onClick={this.click}>
          <i className="material-icons red-text">delete</i>
        </div>
      </div>
    );
  }
  }
}
const styles ={
  delete:{
    position: "absolute",
    top: "5px",
    right: "5px"
  },
  container: {
    position: "relative"
  }
  // image: {
  //   width: "100%",
  //   // height: "10vh"
  // }
}
